/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { DigitizePointLauncherService } from './digitize-point-launcher.service';
import { DigitizePointCommand } from './digitize-point.command';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReportService } from '../../../reports/services/report.service';
import { DigitizePointService } from './digitize-point.service';

export function digitizePointFactory() {
    const command = new DigitizePointCommand();
    command.setDependencies({
        digitizeService: inject(DigitizePointService),
        digitizePointLauncherService: inject(DigitizePointLauncherService)
    });
    return command;
}
